import React, { useState, useEffect } from "react";
// import { DataGrid } from "@mui/x-data-grid";
import AddCustomerForm from "../../../components/AddCustomerForm/AddCustomerForm";
import "./dashboard.scss";
import TableForm from "../../../components/TableForm/TableForm";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";

const Dashboard = () => {
  const [customers, setCustomers] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const handleAddCustomer = (newCustomer) => {
    setCustomers((prev) => [...prev, newCustomer]);
  };

  const handleClick = () => {
    setShowForm(false);
  };

  return (
    <div className="dashboard">
      <div className="top">
        <h2 style={{ fontFamily: "Roboto" }}>Cinammon Lake House</h2>
        <Button className="Btn-Add" onClick={() => setShowForm(!showForm)}>
          <AddIcon className="add-icon" />
          Add Guest
        </Button>
        {showForm && (
          <div className="overlay">
            <AddCustomerForm
              onAdd={handleAddCustomer}
              onClick={handleClick}
              btnName="Add Guest"
              titleName="Guest Information"
              mode="add"
            />
          </div>
        )}
      </div>

      <div className="bottom">
        <TableForm />
      </div>
    </div>
  );
};

export default Dashboard;
